import { shortenFullNameForRow } from "@components/StatsConsole/Widgets/PlayersWidget/functions";
import { useColorContext } from "@stores/ColorContext";
import { useTheme } from "@stores/ThemeContext";
import { T } from "@utils/enums";

interface IRowProps {
    index: number;
    playerHome: string | null;
    playerAway: string | null;
    home: number | null;
    away: number | null;
    colNumberWidthHome: number;
    colNumberWidthAway: number;
}


export const Row = ({ index, playerHome, playerAway, home, away, colNumberWidthHome, colNumberWidthAway }: IRowProps) => {
    const { colors } = useColorContext();
    const { theme } = useTheme();

    return (
        <div data-testid={`row`}
             className="flex flex-row justify-start items-center w-full gap-[4px] h-[16px] mb-[8px]">
          <div className="w-[50%] flex justify-end items-cente">

            <div className={`text-[12px] leading-[16px] font-robotoRegular font-normal whitespace-nowrap`}
                style={{ color: colors?.textColor }}
            >
                {playerHome !== null ? shortenFullNameForRow(playerHome) : ''}
            </div>
            <div className="flex flex-row justify-center items-center ml-[8px]" 
                 style={{ width: colNumberWidthHome }}>
            <div className={`text-[12px] leading-[16px] 
                            font-robotoMedium font-medium px-[4px] rounded-[4px]`}
                style={{ color: colors?.textAdjustedToBGHome, 
                    backgroundColor: colors?.homeColor,
                    borderColor: theme === T.LIGHT ? '#000000' : '#FFFFFF',
                    borderWidth: (home !== null && !(home === 0 && away && away > 0 && index !== 0)) ? '0.6px' : '0px',
                    borderStyle: (home !== null && !(home === 0 && away && away > 0 && index !== 0)) ? 'solid' : 'none' }}
            >
                    {home !== null && !(home === 0 && away && away > 0 && index !== 0) ? home : (index === 0 && (home === null || home === 0) ? 0 : '')}
                </div>
            </div>
          </div>
          <div className="w-[50%] flex justify-start items-center">
            <div className="flex flex-row justify-center items-center mr-[8px]" 
                 style={{ width: colNumberWidthAway}}>
                <div className={`text-[12px] leading-[16px] 
                                font-robotoMedium font-medium px-[4px] rounded-[4px]`}
                    style={{ 
                        color: colors?.textAdjustedToBGAway, 
                        backgroundColor: colors?.awayColor,
                        borderColor: theme === T.LIGHT ? '#000000' : '#FFFFFF',
                        borderWidth: (away !== null && !(away === 0 && home && home > 0 && index !== 0)) ? '0.6px' : '0px',
                        borderStyle: (away !== null && !(away === 0 && home && home > 0 && index !== 0)) ? 'solid' : 'none'
                     }}
                >
                    {away !== null && !(away === 0 && home && home > 0 && index !== 0) ? away : (index === 0 && (away === null || away === 0) ? 0 : '')}
                </div>
            </div>
            <div className={`text-[12px] leading-[16px] font-robotoRegular font-normal whitespace-nowrap`}
                style={{ color: colors?.textColor }}
            >
                {playerAway !== null ? shortenFullNameForRow(playerAway) : ''}
            </div>
          </div>
        </div>
    )
}
